import { usePageGuideStore } from '../../stores/pageGuideStore';
import type { PageGuide } from '../../utils/pageGuide';

/**
 * What Guide offers — and Shift+? too. Its own module so `PageGuideButton` exports
 * components only (fast refresh).
 */

/** One way to start: a guide, at a step. */
export interface GuideEntry { guide: PageGuide; step: number; label: string }

function entriesFor(guides: PageGuide[]): GuideEntry[] {
  const hooks = usePageGuideStore.getState().hooks;
  return guides.flatMap(g => {
    const base: GuideEntry = { guide: g, step: 0, label: guides.length > 1 ? g.name : 'From the start' };
    const here = hooks[g.id]?.here?.() ?? null;
    if (here === null || here <= 0 || here >= g.steps.length) return [base];
    const where = g.steps[here].section ?? g.steps[here].title;
    return [base, { guide: g, step: here, label: `${guides.length > 1 ? `${g.name} — from` : 'From'} ${where} (step ${here + 1})` }];
  });
}
/**
 * ⭐ THE choice — what Guide offers, and what Shift+? offers too (owner, 2026-10-16):
 * the page's guides, overview first, each with its "From <section>" when it knows
 * where the person is. Worked out when asked — `here` reads the tab on screen.
 */
export function guideChoice(stack: PageGuide[]): { title: string; entries: GuideEntry[] } {
  const guides = [...stack].sort((a, b) => (a.level ?? 0) - (b.level ?? 0));
  return { title: guides.length > 1 ? 'Guides for this page' : guides[0]?.name ?? '', entries: entriesFor(guides) };
}
